import { render, staticRenderFns } from "./TabPreferencesThird.vue?vue&type=template&id=96d9d710&scoped=true&"
import script from "./TabPreferencesThird.vue?vue&type=script&lang=js&"
export * from "./TabPreferencesThird.vue?vue&type=script&lang=js&"
import style0 from "./TabPreferencesThird.vue?vue&type=style&index=0&id=96d9d710&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96d9d710",
  null
  
)

export default component.exports